
import { mapGetters } from "vuex";

export default {
  name: "home",

  computed: {
    ...mapGetters("usuario", {
      usuario: "getUsuario",
    }),

    buildVersion() {
      return process.env.VUE_APP_BUILD_VERSION || "LOCAL";
    },
  },
};
